import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import * as moment from 'moment';

interface TimeConfig {
  from: {
    date: Date;
    value: number;
  };
  to: {
    date: Date;
    value: number;
  };
}

require('./bringoz-dates-time-range.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-dates-time-range',
  templateUrl: './bringoz-dates-time-range.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozDatesTimeRangeComponent implements OnInit, OnChanges {
  @Input() from: number;
  @Input() to: number;
  @Input() timeOnly: boolean;
  @Input() dateOnly: boolean;
  @Input() zoneId: string;
  @Input() isRow: boolean;
  @Input() ticks: number = 15;
  @Input() fromPlaceholder: string;
  @Input() toPlaceholder: string;

  @Output() onRangeChange = new EventEmitter<{ from: number, to: number }>();

  timeConfig: TimeConfig;
  isInvalidDates: boolean;

  constructor() {}

  ngOnInit(): void {
    this.setConfig(this.from, this.to);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.from && !changes.from.isFirstChange()) {
      this.setConfig(this.from, this.to);
    }
    if (changes.to && !changes.to.isFirstChange()) {
      this.setConfig(this.from, this.to);
    }
  }

  onFromDateChange(from: number): void {
    const fromDateMoment = moment(from);
    const day = fromDateMoment.date();
    const month = fromDateMoment.month();
    const year = fromDateMoment.year();

    this.timeConfig.from.value = moment(this.timeConfig.from.value)
      .set({
        'year': year,
        'month': month,
        'date': day
      })
      .valueOf();

    if (this.timeConfig.from.date >= this.timeConfig.to.date) {
      this.timeConfig.to.date = moment(from).toDate();
      this.timeConfig.to.value = moment(from)
        .endOf('day')
        .set({
          'minute': 45,
          'second': 0,
          'millisecond': 0
        })
        .valueOf();
    }

    this.setInvalidDates();
    this.onRangeChange.emit({ from: this.timeConfig.from.value, to: this.timeConfig.to.value });
  }

  onFromTimeChange(time: number): void {
    this.timeConfig.from.value = time;
    this.setInvalidDates();
    this.onRangeChange.emit({ from: this.timeConfig.from.value, to: this.timeConfig.to.value });
  }

  onToDateChange(date: number): void {
    this.timeConfig.to.date = moment(date).endOf('day').toDate();
    this.timeConfig.to.value = moment(date)
      .set({
        hour: moment(this.timeConfig.to.value).hours(),
        minute: moment(this.timeConfig.to.value).minutes(),
        second: moment(this.timeConfig.to.value).seconds()
      })
      .valueOf();

    this.setInvalidDates();
    this.onRangeChange.emit({ from: this.timeConfig.from.value, to: this.timeConfig.to.value });
  }

  onToTimeChange(time: number): void {
    this.timeConfig.to.value = time;
    this.setInvalidDates();
    this.onRangeChange.emit({ from: this.timeConfig.from.value, to: this.timeConfig.to.value });
  }

  setInvalidDates(): void {
    this.isInvalidDates = this.timeConfig.from.value >= this.timeConfig.to.value ||
      this.timeConfig.to.value <= this.timeConfig.from.value;
  }

  private setConfig(from: number, to: number): void {
    this.timeConfig = {
      from: {
        date: from ? moment(from).toDate() : undefined,
        value: from ? moment(from).valueOf() : undefined
      },
      to: {
        date: to ? moment(to).toDate() : undefined,
        value: to ? moment(to).valueOf() : undefined
      }
    };
    this.setInvalidDates();
  }
}
